import { ShiftsSwapShiftFragment } from 'generated/resources/graphql'

import { Model } from 'modules/core/lib/mobx-rest'

export type StatusType = 'pending' | 'approved' | 'rejected' | 'expired' | 'cancelled'

export interface Props {
  id: number
  currentShiftId: number
  requestedShiftId: number
  status: string
  reason: string
  teammateReason: string
  managerReason: string
}

class SwapShift extends Model<Props> {
  currentShiftId: number
  requestedShiftId: number
  status: string
  reason: string
  teammateReason: string
  managerReason: string

  constructor(props: Props) {
    super(props)

    this.currentShiftId = props.currentShiftId
    this.requestedShiftId = props.requestedShiftId
    this.status = props.status
    this.reason = props.reason
    this.teammateReason = props.teammateReason
    this.managerReason = props.managerReason
  }

  static types: Record<StatusType, StatusType> = {
    pending: 'pending',
    approved: 'approved',
    rejected: 'rejected',
    expired: 'expired',
    cancelled: 'cancelled',
  }

  static buildFromRequest(props: ShiftsSwapShiftFragment): SwapShift {
    return new SwapShift({
      id: props.id,
      status: props.status,
      reason: props.reason,
      teammateReason: props.teammateReason,
      managerReason: props.managerReason,
      // TODO: To remove once 'dev_shift_management_graphql_migration' is done
      // they are not longer needed because they are alreaday linked to the shift.
      currentShiftId: 0,
      requestedShiftId: 0,
    })
  }
}

export default SwapShift
